import { render, staticRenderFns } from "./EmployeeWorkforceDisplayControls.vue?vue&type=template&id=5082f1d0&scoped=true&"
import script from "./EmployeeWorkforceDisplayControls.vue?vue&type=script&lang=js&"
export * from "./EmployeeWorkforceDisplayControls.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeWorkforceDisplayControls.vue?vue&type=style&index=0&id=5082f1d0&scoped=true&lang=css&"
import style1 from "./EmployeeWorkforceDisplayControls.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5082f1d0",
  null
  
)

export default component.exports